/**
 * @generated SignedSource<<609f3f4f3d9fb919e146d1bbc118e2f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileRateFields_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CompensationSummary_User" | "ExperienceSummary_User" | "RateEditDialog_User">;
  readonly " $fragmentType": "ProfileRateFields_User";
};
export type ProfileRateFields_User$key = {
  readonly " $data"?: ProfileRateFields_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileRateFields_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileRateFields_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompensationSummary_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExperienceSummary_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RateEditDialog_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8d5f0db05c3ad74c85c0b8570c98c9b6";

export default node;
